import { authSelectors } from 'ducks/auth'
import UiRoute from 'elements/UiRoute'
import { CheckoutLoadingPage } from 'loadingPages/CheckoutLoadingPage'
import { ShopLoadingPage } from 'loadingPages/ShopLoadingPage'
import GenericErrorPage from 'pages/auth/sso/GenericErrorPage'
import { lazy } from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { useFeatureFlag } from 'util/featureFlags'
// import OrgWalletTransactionList from './resources/walletTransactions/OrgWalletTransactionList'

const RootRedirect = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated)
  return <Redirect to={isAuthenticated ? '/home' : '/login'} />
}

const WalletProductsRedirect = () => {
  const orgId = useSelector(authSelectors.getOrgId)
  return <Redirect to={`/external_api_keys/${orgId}`} />
}

// Send users on the new scheduling experience to /activities/calendar,
// other users still see the legacy Events page at /calendar
const LegacyCalendarPage = lazy(() => import('./resources/events/Events'))
const CalendarRedirect = () => {
  const schedulingV3Enabled = !!useFeatureFlag('scheduling_v3', 'on')
  if (schedulingV3Enabled) {
    return <Redirect to="/activities/calendar" />
  }
  return <LegacyCalendarPage />
}

//To do: refactor PageRegister by using props
export default [
  /*
  AP: I have no idea why this extra route is required to prevent redirecting from / to /projects which is
  the first resource registered
  */

  <UiRoute path={'/'} exact component={RootRedirect} />,
  <UiRoute path={'/projects/view/:id'} lazy={() => import('./resources/projects/projects3')} />,

  <UiRoute
    path="/google-profile/:org_id_or_slug"
    lazy={() => import('./pages/googleLeads/elements/profile/ProfilePublic')}
    noLayout
    noAuth
  />,
  <UiRoute exact path="/profile_page/" lazy={() => import('./pages/profilePage/ProfilePageBuilder')} />,
  <UiRoute
    exact
    path="/myenergy/checkout"
    lazy={() => import('./projectSections/sections/proposal/ProjectCashflowCheckoutPage')}
    noLayout
    noAuth
  />,
  <UiRoute path="/profile/:org_id_or_slug" lazy={() => import('./pages/profilePage/ProfilePublic')} noLayout noAuth />,
  <UiRoute
    exact
    path="/projects/:projectId/checkout"
    lazy={() => import('./projectSections/sections/proposal/ProjectCashflowCheckoutPage')}
    noLayout
  />,
  <UiRoute path={'/projects/:id'} lazy={() => import('./projectSections/ProjectSectionsWithPermissions')} />,
  <UiRoute path={'/home'} lazy={() => import('./pages/home/PageHome')} />,
  <UiRoute path={'/academy'} lazy={() => import('./pages/learning/MyLearning')} />,
  <UiRoute path={`/configuration`} lazy={() => import('./pages/settings/PageConfiguration')} />,
  <UiRoute exact path="/register" lazy={() => import('./pages/auth/RegisterEntryGate')} noLayout noAuth />,
  <UiRoute
    exact
    path="/ada-setup"
    lazy={() => import('./pages/auth/components/auth3_0/AdaBusinessProfile')}
    noLayout
    noAuth
  />,
  <UiRoute exact path="/ada-register" lazy={() => import('./pages/auth/AdaMultiStepRegisterPage')} noLayout noAuth />,
  <UiRoute exact path="/register-legacy" lazy={() => import('./pages/auth')} noLayout noAuth />,
  // Backward Compatibility -> Redirect /register-3 to /register for bookmarked links
  <UiRoute exact path="/register-3" component={() => <Redirect to="/register" />} noLayout noAuth />,
  <UiRoute exact path="/network_tariff_groups/create" component={() => <Redirect to="/network_tariffs/create" />} />,
  <UiRoute
    exact
    path="/register-multistep"
    lazy={() => import('./pages/auth/MultiStepRegisterPage')}
    noLayout
    noAuth
  />,
  <UiRoute path="/register-*" lazy={() => import('./pages/auth')} noLayout noAuth />,
  <UiRoute exact path="/logout" lazy={() => import('./pages/PageLogout')} noLayout noAuth />,
  <UiRoute exact path="/password-reset" lazy={() => import('./pages/auth/PasswordResetPage')} noLayout noAuth />,
  <UiRoute exact path="/login-modal" lazy={() => import('./pages/auth')} noLayout noAuth />,
  <UiRoute
    path="/team-member-registration/"
    lazy={() => import('./pages/teamMemberRegistration/TeamMemberRegistration')}
    noLayout
    noAuth
  />,
  <UiRoute exact path="/login-with-nearmap" lazy={() => import('./pages/auth/LoggingInWithNearmap')} noLayout noAuth />,
  <UiRoute
    exact
    path="/login-nearmap-admin-required"
    lazy={() => import('./pages/auth/LoginNearmapAdminRequired')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-email-clash-logged-in"
    lazy={() => import('./pages/auth/LoginNearmapEmailClashLoggedIn')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-email-clash"
    lazy={() => import('./pages/auth/LoginNearmapEmailClashed')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-existing-account-new-user-email-clash"
    lazy={() => import('./pages/auth')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-existing-account-new-user-email-clash-logged-in"
    lazy={() => import('./pages/auth')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-choose-create-or-upgrade"
    lazy={() => import('./pages/auth/LoginNearmapChooseCreateOrUpgrade')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/login-nearmap-product-not-provisioned"
    lazy={() => import('./pages/auth/LoginNearmapProductionNotProvisioned')}
    noLayout
    noAuth
  />,
  <UiRoute exact path="/login-nearmap-email-mismatch" lazy={() => import('./pages/auth')} noLayout noAuth />,
  <UiRoute exact path="/sso-login" lazy={() => import('./pages/auth/sso/SSOAuthFlow')} noLayout noAuth />,
  <UiRoute
    exact
    path="/sso-login-complete"
    render={({ match, location }) => {
      return (
        <GenericErrorPage
          message={'Login complete. You may now close this window and return to the application.'}
          showBackButton={false}
        />
      )
    }}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/logging-in-with-query-token"
    lazy={() => import('./pages/auth/LoginWithQueryToken')}
    noLayout
    noAuth
  />,
  // Move login-* route until after all the login-nearmap... and login-with.nearmap... and login-modal so they will
  // be matched before the wildcard login- is matched
  <UiRoute path="/login" lazy={() => import('./pages/auth')} noLayout noAuth />,
  <UiRoute path="/login-*" lazy={() => import('./pages/auth')} noLayout noAuth />,

  <UiRoute exact path="/redirect-to-login-with-nearmap" lazy={() => import('./pages/auth')} noLayout noAuth />,
  <UiRoute
    path="/password-reset-requested"
    lazy={() => import('./pages/auth/PasswordResetRequestedPage')}
    noLayout
    noAuth
  />,
  <UiRoute path="/password-set-form" lazy={() => import('./pages/auth/PasswordResetForm')} noLayout noAuth />,
  <UiRoute path="/password-reset-form" lazy={() => import('./pages/auth/PasswordResetForm')} noLayout noAuth />,
  <UiRoute path="/password-reset-complete" lazy={() => import('./pages/auth/PasswordResetComplete')} noLayout noAuth />,
  <UiRoute path="/action-result" lazy={() => import('./pages/actionResult/ActionResult')} noLayout noAuth />,

  <UiRoute exact path="/password-change-form" lazy={() => import('./pages/auth/ChangePassword')} noAuth />,
  <UiRoute exact path="/email-preferences" lazy={() => import('./pages/auth/EmailPreferences')} />,
  <UiRoute exact path="/password-change-complete" lazy={() => import('./pages/auth/PasswordChangeComplete')} />,
  <UiRoute exact path="/email-change-form" lazy={() => import('./pages/auth/ChangeEmail')} />,
  <UiRoute exact path="/email-change-complete" lazy={() => import('./pages/auth/EmailChangeComplete')} />,
  <UiRoute path="/myenergy" lazy={() => import('./projectSections/sections/proposal/MyEnergy')} noLayout noAuth />,
  <UiRoute path="/data_sharing" lazy={() => import('./resources/orgs/DataSharing')} />,
  <UiRoute path={'/control'} lazy={() => import('./pages/dashboard/DashboardRedirect')} />,
  <UiRoute
    path={'/shop'}
    lazy={() => import('./pages/ordering/ShopPageWithPermissions')}
    loading={<ShopLoadingPage />}
  />,
  <UiRoute
    path={'/multi_project_ordering'}
    lazy={() => import('./pages/ordering/ShopPageWithPermissions')}
    loading={<ShopLoadingPage />}
  />,
  <UiRoute path={'/checkout'} lazy={() => import('./pages/ordering/CheckoutPage')} loading={<CheckoutLoadingPage />} />,
  <UiRoute
    exact
    path="/finance-marketplace"
    lazy={() => import('./pages/financeMarketplace/StandaloneFinanceMarketplacePage')}
    noLayout
    noAuth
  />,
  <UiRoute path={'/manage_orders'} lazy={() => import('./pages/manageOrders/ManageOrdersPageWithPermissions')} />,
  <UiRoute path={'/quotes'} lazy={() => import('./pages/quotes/QuotesPageWithPermissions')} />,
  <UiRoute path={'/inventory'} lazy={() => import('./pages/inventory/routes/InventoryPageWithPermissions')} />,
  <UiRoute path={`/staff_reports`} lazy={() => import('./pages/PageStaffReports')} />,
  <UiRoute path={'/market_data_report'} lazy={() => import('./pages/reports/PagePivotReport')} />,
  <UiRoute
    path={'/market_data_report_dashboard_print'}
    lazy={() => import('./pages/reports/PageDashboardReportPrint')}
  />,
  <UiRoute path={'/market_data_report_dashboard'} lazy={() => import('./pages/reports/PageDashboardReport')} />,
  <UiRoute path={`/feedback`} lazy={() => import('./pages/feedback/FeedbackDashboardWithPermissions')} />,
  <UiRoute path={`/config_save`} lazy={() => import('./pages/PageConfigSave')} />,
  <UiRoute path={`/org_verification`} lazy={() => import('./pages/PageStaffOrgVerification')} />,
  <UiRoute
    path={`/scheduled_events/runs/:runId`}
    lazy={() => import('./pages/scheduled_events/PageScheduledEventRunDetail')}
  />,
  <UiRoute path={`/scheduled_events`} lazy={() => import('./pages/scheduled_events/PageScheduledEvents')} />,
  <UiRoute exact path="/calendar" component={CalendarRedirect} />,
  <UiRoute exact path="/activities/calendar" lazy={() => import('./resources/calendar/Calendar')} />,
  <UiRoute
    exact
    path="/activities/scheduling"
    lazy={() => import('./resources/calendar/Calendar').then((m) => ({ default: m.Scheduling }))}
  />,
  <UiRoute path={`/quick-start`} lazy={() => import('./pages/PageQuickStart')} />,
  <UiRoute exact path="/business-process" lazy={() => import('./pages/BusinessProcess')} />,
  <UiRoute exact path="/configure-mfa" lazy={() => import('./pages/home/OrgVerificationAndMfa')} />,
  <UiRoute exact path="/org-verification" lazy={() => import('./pages/auth/OrgVerificationDialogPage')} />,
  <UiRoute exact path="/supplier/product_upload" lazy={() => import('./pages/seller/UploadProductsPage')} />,
  <UiRoute exact path="/supplier/price_tier" lazy={() => import('./pages/seller/ManagePriceTiersPage')} />,
  <UiRoute exact path="/supplier/stock_locations" lazy={() => import('./pages/seller/ManageStockLocationsPage')} />,
  <UiRoute exact path="/supplier/configuration" lazy={() => import('./pages/seller/SellerConfiguration')} />,
  <UiRoute exact path="/supplier/invite_customers" lazy={() => import('./pages/seller/InviteCustomersPage')} />,
  <UiRoute exact path="/shop_suppliers" lazy={() => import('./pages/seller/HardwareSuppliersPage')} />,
  <UiRoute
    exact
    path="/hardware_supplier_preferences"
    slug="pages.hardware_preferred_suppliers_page"
    lazy={() => import('./pages/seller/HardwareSupplierPreference')}
  />,

  <UiRoute
    exact
    path="/payments_configurations"
    lazy={() => import('./pages/cashFlow/configuration/CashFlowConfigurationPage')}
  />,
  <UiRoute exact path="/mfa/:page" lazy={() => import('./pages/mfa/MfaActiveSessionWrapper')} />,
  <UiRoute exact path="/csv_upload" lazy={() => import('./pages/PageUploadCsv')} />,
  <UiRoute path="/ui_library" lazy={() => import('./pages/uiLibrary/UILibrary')} />,

  <UiRoute exact path="/google_leads_config/" lazy={() => import('./pages/googleLeads/GoogleLeadsForm')} />,

  <UiRoute exact path="/customer_checkout/:id" lazy={() => import('./resources/checkout/EditCustomerCheckout')} />,
  <UiRoute
    exact
    path="/cashflow/configure/accounting/connection"
    lazy={() => import('./pages/cashFlow/configuration/accounting/AccountingIntegrationConnect')}
    noLayout
  />,
  <UiRoute
    exact
    path="/external_api_keys/solvera/form"
    lazy={() => import('./pages/solvera/SolveraApplicationPage')}
  />,
  <UiRoute
    exact
    path="/external_api_keys/:id/:result?/:partner?"
    lazy={() => import('./resources/externalKeys/EditExternalKeys')}
  />,
  <UiRoute exact path="/wallet_products" component={WalletProductsRedirect} />,
  <UiRoute exact path="/api_usage" lazy={() => import('./pages/apiUsage/ApiUsagePage')} />,
  <UiRoute
    exact
    path="/user_sessions/:userId"
    lazy={() => import('./resources/userSessions/UserSessionDetailPage')}
  />,
  <UiRoute exact path="/staff/security" lazy={() => import('./pages/staff/security/SecurityHomePage')} />,
  <UiRoute
    exact
    path="/staff/deactivate_users"
    lazy={() => import('./pages/staff/security/deactivate/BulkDeactivateUsersPage')}
  />,
  <UiRoute
    exact
    path="/staff/reactivate_users"
    lazy={() => import('./pages/staff/security/reactivate/BulkReactivateUsersPage')}
  />,
  <UiRoute
    exact
    path="/staff/suspicious_activity"
    lazy={() => import('./pages/staff/security/suspiciousActivity/SuspiciousActivityPage')}
  />,
  <UiRoute
    exact
    path="/staff/suspicion_signals"
    lazy={() => import('./pages/staff/security/suspicionSignals/SuspicionSignalsPage')}
  />,
  <UiRoute
    exact
    path="/staff/throttle_inspection"
    lazy={() => import('./pages/staff/security/throttleInspection/ThrottleInspectionPage')}
  />,
  <UiRoute exact path="/staff/operations" lazy={() => import('./pages/staff/operations/OperationsHomePage')} />,
  <UiRoute exact path="/staff/emails" lazy={() => import('./pages/staff/emails/EmailInvestigatorPage')} />,
  <UiRoute exact path="/staff/query_runner" lazy={() => import('./pages/staff/queryRunner/QueryRunnerPage')} />,
  <UiRoute
    exact
    path="/staff/trails_analyzer"
    lazy={() => import('./pages/staff/trailsAnalyzer/TrailsAnalyzerPage')}
  />,
  <UiRoute
    exact
    path="/staff/audit_trail"
    lazy={() => import('./pages/staff/auditTrail/StaffAuditTrailPage')}
  />,
  <UiRoute exact path="/wallet_transactions" component={() => <Redirect to="/wallet?tab=activity" />} />,
  <UiRoute exact path="/wallet" lazy={() => import('./resources/wallet/WalletHome')} />,
  <UiRoute
    path="/stipulation_upload/:orgId/:projectId/:partnerId/:partner"
    lazy={() => import('./myenergy/selectionComponent/financeStipulations/StipUploadPage')}
    noLayout
  />,
  <UiRoute
    path="/projects/:projectId/payment/:paymentRequestId"
    lazy={() => import('./myenergy/dialogs/checkout/cashFlow/HostedPaymentsPage')}
    noLayout
    noAuth
  />,
  <UiRoute
    path="/payment_preview"
    lazy={() => import('./pages/cashFlow/configuration/directPayment/PaymentTemplatePreview')}
    noLayout
  />,
  <UiRoute
    path="/payment/group/:groupedPaymentId"
    lazy={() => import('./myenergy/dialogs/checkout/cashFlow/HostedPaymentsPage')}
    noLayout
    noAuth
  />,
  <UiRoute
    path="/payment/:paymentRequestId"
    lazy={() => import('./myenergy/dialogs/checkout/cashFlow/HostedPaymentsPage')}
    noLayout
    noAuth
  />,
  <UiRoute
    exact
    path="/payment_options/swap"
    lazy={() => import('./resources/paymentOptions/swapPaymentOptions/SwapPaymentOptionsPage')}
  />,
  <UiRoute exact path="/connected_orgs/:id/shared" lazy={() => import('./resources/connectedOrgs/ShareSummary')} />,
  <UiRoute exact path="/org_linking/:partner" lazy={() => import('./pages/partners/PartnerOrgLinking')} />,
  <UiRoute exact path={`/org_correction/:id`} lazy={() => import('./pages/orgSwitcher/QueryParamOrgSwitcher')} />,
  <UiRoute
    path="/cashflow_documents/:orgId"
    lazy={() => import('./pages/cashFlow/configuration/documents/HostedUploadDocumentPage')}
    noLayout
  />,
  <UiRoute path={'/cashflow'} lazy={() => import('./pages/cashFlow/CashFlowLandingPage')} />,
  <UiRoute path={'/recheck/authorized'} lazy={() => import('./pages/auth/recheck')} noLayout noAuth />,
  <UiRoute path="/expo" lazy={() => import('./pages/expo/ExpoSection')} noLayout noAuth />,
  <UiRoute path="/redirect" lazy={() => import('./pages/DocusignRedirect')} noLayout noAuth />,
  <UiRoute path="/pandadoc_redirect" lazy={() => import('./pages/PandadocRedirect')} noLayout noAuth />,
  <UiRoute exact path="/partner_settings" lazy={() => import('./pages/PartnerSettings')} />,
  <UiRoute
    exact
    path="/company_notifications"
    lazy={() => import('./pages/companyNotifications/NotificationsPage')}
  />,
  <UiRoute path={'/supplier_assist'} lazy={() => import('./pages/supplierAssist')} />,
  <UiRoute
    path="/supplier-invite/:token"
    lazy={() => import('./pages/supplierInvite/AcceptInvitePage')}
    noLayout
    noAuth
  />,
  <UiRoute
    key="utility-tariff-all-rate-rows"
    exact
    path="/utility_tariff_groups/all_rate_rows"
    lazy={() =>
      import('./resources/utilityTariffGroups/pages/UtilityTariffAllRateRowsPage').then((m) => ({
        default: m.UtilityTariffAllRateRowsPage,
      }))
    }
  />,
  <UiRoute
    key="utility-tariff-catalogue-create"
    exact
    path="/utility_tariff_groups/create"
    lazy={() =>
      import('./resources/utilityTariffGroups/pages/UtilityTariffCatalogueCreatePage').then((m) => ({
        default: m.UtilityTariffCatalogueCreatePage,
      }))
    }
  />,
  <UiRoute
    key="utility-tariff-version-create"
    exact
    path="/utility_tariff_groups/:groupId/versions/create"
    lazy={() =>
      import('./resources/utilityTariffGroups/pages/UtilityTariffVersionCreatePage').then((m) => ({
        default: m.UtilityTariffVersionCreatePage,
      }))
    }
  />,
  <UiRoute
    key="utility-tariff-version-edit"
    exact
    path="/utility_tariff_groups/:groupId/versions/:tariffId/edit"
    lazy={() =>
      import('./resources/utilityTariffGroups/pages/UtilityTariffVersionEditPage').then((m) => ({
        default: m.UtilityTariffVersionEditPage,
      }))
    }
  />,
]
